/**
 * API Configuration
 */

export const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
} as const;

export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/auth/login',
    VALIDATE: '/auth/validate',
  },

  // Balance
  BALANCE: {
    GET_DEDUCTIBLE: '/balance/deductible',
    GET_AUDIT: '/balance/audit-premium',
  },

  // Payments
  PAYMENTS: {
    PREPARE: '/payments/prepare',
    CALLBACK: '/payments/callback',
    RESULT: (token: string) => `/payments/result/${token}`,
  },

  // Statements
  STATEMENTS: {
    GENERATE: '/statements/generate',
    DOWNLOAD: (token: string) => `/statements/download/${token}`,
  },

  // Configuration
  CONFIGURATION: {
    CONTACT: '/configuration/contact',
  },

  // Health
  HEALTH: '/health',
} as const;
